import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_PATH as employeesPath } from './constants';
import {
  CREATE_EMPLOYEE_CONTRACT_RESPONSE,
  DEFAULT_EMPLOYEE,
} from './fixtures';

export const employeesHandlers = [
  http.get(`*${employeesPath}/:id`, () =>
    HttpResponse.json(DEFAULT_EMPLOYEE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.patch(`*${employeesPath}/:id`, () =>
    HttpResponse.json(DEFAULT_EMPLOYEE, {
      status: HTTPStatusCodes.OK,
    }),
  ),
  http.post(`*${employeesPath}/:id/contracts`, () =>
    HttpResponse.json(CREATE_EMPLOYEE_CONTRACT_RESPONSE, {
      status: HTTPStatusCodes.RESOURCE_CREATED,
    }),
  ),
];
